var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceHistoryIconInverted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.57227V9.21959L13.0451 11.2665L14.2674 9.30666L11.875 7.92498V4.5723L9.5 4.57227Z",
    fill: "#287C87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 0C6.50813 0 3.04918 2.98718 2.46988 6.85712H0L3.56251 10.2857L7.12502 6.85712H4.87003C5.4218 4.25221 7.82037 2.28569 10.6875 2.28569C13.9613 2.28569 16.625 4.84932 16.625 7.99997C16.625 11.1506 13.9613 13.7143 10.6875 13.7143C8.78276 13.7143 6.98004 12.8248 5.86559 11.3359L3.93823 12.6708C5.49798 14.7556 8.02085 16 10.6875 16C15.2711 16 19 12.4107 19 8C19 3.58928 15.2711 0 10.6875 0Z",
    fill: "#287C87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceHistoryIconInverted);
export default __webpack_public_path__ + "static/media/price-history-icon-inverted.b44f1b4f9f133bb5c55b5e4db202b66f.svg";
export { ForwardRef as ReactComponent };